const defaultProjectMediaFilesSearchTerm = '';

export default defaultProjectMediaFilesSearchTerm;
